import React from 'react';
import PropTypes from 'prop-types';
import { RiCloseLine } from 'react-icons/ri';

import {
  StyledAnnotationOptionPanelHeader,
  StyledAnnotationOptionPanelHeaderActions,
  StyledAnnotationOptionPanelHeaderReset,
  StyledAnnotationOptionPanelHeaderTitle,
} from './AnnotationOptionPanelHeader.styled';

const AnnotationOptionPanelHeader = ({
  title,
  closeLabel,
  resetLabel,
  canReset = false,
  onClose,
  onReset,
}) => (
  <StyledAnnotationOptionPanelHeader className="respark_annotation-option-panel-header">
    <StyledAnnotationOptionPanelHeaderTitle className="respark_annotation-option-panel-header__title">
      {title}
    </StyledAnnotationOptionPanelHeaderTitle>
    <StyledAnnotationOptionPanelHeaderActions className="respark_annotation-option-panel-header__actions">
      {canReset ? (
        <StyledAnnotationOptionPanelHeaderReset
          type="button"
          className="respark_annotation-option-panel-header__reset"
          onClick={onReset}
        >
          {resetLabel}
        </StyledAnnotationOptionPanelHeaderReset>
      ) : null}
      <button
        type="button"
        className="respark_annotation-option-panel-header__close"
        title={closeLabel}
        aria-label={closeLabel}
        onClick={onClose}
      >
        <RiCloseLine size={18} aria-hidden />
      </button>
    </StyledAnnotationOptionPanelHeaderActions>
  </StyledAnnotationOptionPanelHeader>
);

AnnotationOptionPanelHeader.propTypes = {
  title: PropTypes.string.isRequired,
  closeLabel: PropTypes.string.isRequired,
  resetLabel: PropTypes.string.isRequired,
  canReset: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onReset: PropTypes.func,
};

export default AnnotationOptionPanelHeader;
